module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-Pillar-Page-Resource-w960.6c4c1e43.jpg";